export const extractLastTwo = (path) => {
  const parts = path.split('/').filter(Boolean); // removes empty strings
  if (parts.length < 3) return parts?.join('-');
  return `${parts[parts.length - 3]}-${parts[parts.length - 2]}`;
}

export const getUserDetails = () => {
  const profileData = JSON.parse(localStorage.getItem("UserProfile"));
  const userProfile = profileData;
  let user_id = null;
  let user_name = null;
  let ask_ai_user_id = null;
  let user_folder_id = null;
  let idToken = null;
  let gmail = null;
  let full_name = null;
  let isContractor = false;
  let isAdminID = false;

  if (userProfile) {
    user_name = userProfile.name// extractNameFromEmail(userProfile.name);
    user_id = userProfile.username;
    ask_ai_user_id = userProfile.username;
    user_folder_id = userProfile.homeAccountId;
    idToken = userProfile.idToken;
    gmail = userProfile.username;
    full_name = userProfile.name // extractNameFromEmail(userProfile.username);
    // var { firstName, lastName } = getFirstAndLastName(full_name);
    // isContractor = !EXCLUDED_EMAILS.includes(gmail) && gmail.includes("-CW@otsuka-us.com");
    // isAdminID = ADMIN_EMAILS.includes(gmail);


    // You can also call `fetchUserPhoto(accessToken)` if necessary
    // fetchUserPhoto(accessToken);

  }
  return { user_name, user_id, user_folder_id, ask_ai_user_id, idToken, gmail, full_name };
};

export function downloadExcelFromBase64(base64Data, fileName = "review_table.xlsx") {
  // Convert base64 to a Blob
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  // MIME type for Excel
  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Create a temporary download link
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

export const normalizeVersions = (versions) => {
    const sorted = [...versions].sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
    );

    return sorted.map((v, index) => ({
        ...v,
        versionLabel: `v${index + 1}`,
        // isLatest: index === sorted.length - 1,
    })).reverse();
};

export const transformProtocolToSessions = (protocols = []) => {
    const latestId = protocols[0]?.protocol_id;

    return protocols.map((protocol) => {
        const dateObj = new Date(protocol.created_at);

        return {
            key: protocol.protocol_id,
            date: new Intl.DateTimeFormat("en-GB", {
                day: "2-digit",
                month: "short",
                hour: "2-digit",
                minute: "2-digit",
            }).format(dateObj),

            sessionId: `${protocol.protocol_id}-${protocol.protocol_name}`,
            protocol_id: protocol.protocol_id,
            protocol: protocol.protocal_name,

            isActive: protocol.protocol_id === latestId,
        };
    });
};